import { render, staticRenderFns } from "./UGroups.vue?vue&type=template&id=39ee6ba6&"
import script from "./UGroups.vue?vue&type=script&lang=js&"
export * from "./UGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports